import { render, staticRenderFns } from "./SavedCoursePlanPage.vue?vue&type=template&id=a0ad23be&scoped=true&"
import script from "./SavedCoursePlanPage.vue?vue&type=script&lang=js&"
export * from "./SavedCoursePlanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ad23be",
  null
  
)

export default component.exports